/* =====================================================================
   PhantomR — fitment finder. Cascading Make -> Model (-> optional Cab).
   Reads a JSON blob (make/model/cab/type/title/url/price/image) emitted
   by snippets/fitment-widget.liquid. Progressive enhancement: falls back
   to the make's collection when there's no exact match.
   ===================================================================== */
(function () {
  "use strict";
  var U = (window.PhantomR && window.PhantomR.utils) || {};

  function esc(s) { var d = document.createElement("div"); d.textContent = s == null ? "" : s; return d.innerHTML; }
  function escAttr(s) { return esc(s).replace(/"/g, "&quot;"); }
  function uniqSorted(a) { return a.filter(function (v, i) { return v && a.indexOf(v) === i; }).sort(); }
  function handle(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, ""); }
  function money(cents) {
    if (typeof cents !== "number") return "";
    return U.formatMoney ? U.formatMoney(cents, window.PhantomR.moneyFormat) : "$" + (cents / 100).toFixed(2);
  }

  function init(scope) {
    if (scope.__fitInit) return;
    var dataEl = scope.querySelector("[data-fitment-data]");
    if (!dataEl) return;
    var items;
    try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
    scope.__fitInit = true;

    var makeSel = scope.querySelector("[data-fitment-make]");
    var modelSel = scope.querySelector("[data-fitment-model]");
    var cabField = scope.querySelector("[data-fitment-cab-field]");
    var cabSel = scope.querySelector("[data-fitment-cab]");
    var form = scope.querySelector("[data-fitment]");
    var result = scope.querySelector("[data-fitment-result]");
    var fallback = scope.querySelector("[data-fitment-fallback]");
    var fallbackText = scope.querySelector("[data-fitment-fallback-text]");
    var browse = scope.querySelector("[data-fitment-browse]");
    var requestUrl = scope.getAttribute("data-request-url") || "";

    var makePh = makeSel.options[0] ? makeSel.options[0].textContent : "Select make";
    var modelPh = modelSel.options[0] ? modelSel.options[0].textContent : "Select model";

    var byMake = {};
    items.forEach(function (it) { (byMake[it.make] = byMake[it.make] || []).push(it); });

    // Build make options from the data (only makes that have at least one modelled kit)
    uniqSorted(Object.keys(byMake)).forEach(function (m) {
      var o = document.createElement("option"); o.value = m; o.textContent = m; makeSel.appendChild(o);
    });

    function fill(sel, values, placeholder) {
      sel.innerHTML = "";
      var ph = document.createElement("option"); ph.value = ""; ph.textContent = placeholder; sel.appendChild(ph);
      values.forEach(function (v) { var o = document.createElement("option"); o.value = v; o.textContent = v; sel.appendChild(o); });
    }

    function clearResult() { result.hidden = true; result.innerHTML = ""; }

    function updateFallback(make) {
      if (!fallback) return;
      if (!make) { fallback.hidden = true; return; }
      if (browse) {
        browse.href = "/collections/" + handle(make);
        browse.textContent = "Browse all " + make + " kits";
      }
      if (fallbackText) fallbackText.textContent = "Can’t find your exact model?";
      fallback.hidden = false;
    }

    function onMake() {
      clearResult();
      var m = makeSel.value;
      if (cabField) cabField.hidden = true;
      if (!m) { fill(modelSel, [], modelPh); modelSel.disabled = true; if (fallback) fallback.hidden = true; return; }
      var models = uniqSorted((byMake[m] || []).map(function (i) { return i.model; }));
      fill(modelSel, models, modelPh);
      modelSel.disabled = false;
      updateFallback(m);
    }

    function currentMatches() {
      var m = makeSel.value, mod = modelSel.value;
      var c = (cabField && !cabField.hidden && cabSel) ? cabSel.value : "";
      return (byMake[m] || []).filter(function (i) { return i.model === mod && (!c || i.cab === c); });
    }

    function onModel() {
      clearResult();
      var m = makeSel.value, mod = modelSel.value;
      if (cabField) cabField.hidden = true;
      if (!mod) { updateFallback(m); return; }
      var list = (byMake[m] || []).filter(function (i) { return i.model === mod; });
      var cabs = uniqSorted(list.map(function (i) { return i.cab; }));
      if (cabField && cabSel && cabs.length > 1) {
        fill(cabSel, cabs, "Any cab"); cabSel.disabled = false; cabField.hidden = false;
      }
      showResult(list);
    }

    function onCab() { showResult(currentMatches()); }

    function card(it) {
      var price = money(it.price);
      return '<a class="fitment-card" href="' + escAttr(it.url) + '">' +
        (it.image ? '<span class="fitment-card__media media"><img src="' + escAttr(it.image) + '" alt="" loading="lazy" width="64" height="64"></span>' : "") +
        '<span class="fitment-card__body">' +
          (it.type ? '<span class="fitment-card__type">' + esc(it.type) + "</span>" : "") +
          '<span class="fitment-card__title">' + esc(it.title) + "</span>" +
          (price ? '<span class="fitment-card__price">' + price + (it.available ? "" : " · sold out") + "</span>" : "") +
        "</span>" +
        '<span class="fitment-card__cta" aria-hidden="true">View kit →</span></a>';
    }

    function showResult(matches) {
      if (!matches || !matches.length) { clearResult(); return; }
      result.innerHTML = '<p class="fitment__result-label">' + matches.length + (matches.length === 1 ? " kit" : " kits") + " for your vehicle</p>" +
        matches.map(card).join("");
      result.hidden = false;
    }

    function onSubmit(e) {
      e.preventDefault();
      var m = makeSel.value, mod = modelSel.value;
      if (m && mod) {
        var matches = currentMatches();
        if (matches.length === 1) { window.location.href = matches[0].url; return; }
        if (matches.length > 1) { showResult(matches); return; }
      }
      if (m) { window.location.href = "/collections/" + handle(m); return; }
      makeSel.focus();
    }

    makeSel.addEventListener("change", onMake);
    modelSel.addEventListener("change", onModel);
    if (cabSel) cabSel.addEventListener("change", onCab);
    form.addEventListener("submit", onSubmit);
  }

  function boot() { document.querySelectorAll("[data-fitment-scope]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("shopify:section:load", function (e) {
    e.target.querySelectorAll("[data-fitment-scope]").forEach(init);
  });
})();
